const serviceTypes = {
    pr: 'Vendor Rides',
    mt: 'Mileage Tracker',
    vi: 'Video Interpretation',
    opi: 'Audio Rollover'
};
Object.freeze(serviceTypes);
export default serviceTypes;